export const roundTo = (num: number, by: number) => Math.round(num * (10 ** by)) / (10 ** by);
export const log = (num: number, base = Math.E) => Math.log(num) / Math.log(base);